/**
 * Created by fworld on 2019/9/19.
 */
export default {
    name: 'delivery',
    path: '/factory/delivery',
    meta: {title: '经销商管理'},
    component: () => import('@/pages/redirect'),
    redirect: {name: 'factory.delivery.list'},
    children: [
        {
            name: 'factory.delivery.list',
            path: 'list',
            meta: {title: '经销商列表'},
            component: () => import('@/pages/Factory/Delivery/list'),
        },
    ]
}
